// Homepage V2 Standalone JavaScript
// import $ from 'jquery';

class HomepageV2 {
    constructor(el) {
        this.page = el;
        this.init();
    }

    init() {
        console.log('HomepageV2 initialized');
    }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    const page = document.getElementById("homepage-content-v2");
    if (page) {
        new HomepageV2(page);
    }
}); 